import {ConfigProvider} from '../config/configProvider';
import {ScriptsProvider} from '../providers/scriptsProvider';

class GoogleCaptcha
{
    /** @param {CallableFunction|null} callback */
    static init(callback = null) {
        let recaptchaElements = document.querySelectorAll('[data-form="re-captcha"]'),
            scriptAttachedCallback = () => {
                if (typeof grecaptcha === 'undefined' || typeof grecaptcha.render !== 'function') {
                    setTimeout(scriptAttachedCallback, 200);
                    return;
                }

                Array.from(recaptchaElements).forEach((element) => {
                    if (element.getAttribute('data-type') === 'hidden') {
                        return;
                    }

                    this.load(element);
                });

                if (callback) {
                    callback();
                }
            };

        if (!recaptchaElements.length) {
            return;
        }

        if (typeof grecaptcha === 'undefined') {
            let lang = ConfigProvider.get('captcha_lang');
            ScriptsProvider.add('https://www.google.com/recaptcha/api.js?hl=' + lang, scriptAttachedCallback);
        } else {
            scriptAttachedCallback();
        }
    }

    static load(recaptchaElement) {
        if (typeof grecaptcha === 'undefined') {
            this.init(() => this.load(recaptchaElement));
        } else if (recaptchaElement && recaptchaElement.innerHTML === '') {
            grecaptcha.render(recaptchaElement, {
                'sitekey': recaptchaElement.getAttribute('data-sitekey'),
                'callback': () => recaptchaElement.dispatchEvent(new Event('verified')),
            });
        }
    }

    static reset() {
        let recaptchaElements = document.querySelectorAll('[data-form="re-captcha"]');

        if (recaptchaElements.length && typeof grecaptcha !== 'undefined') {
            for (let index = 0; index < recaptchaElements.length; index++) {
                try { grecaptcha.reset(index); } catch(event) {}
            }
        }
    }
}

export {GoogleCaptcha};
